/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseScheduledChangeDetailData } from './genericApiResponseScheduledChangeDetailData';
import type { GenericApiResponseScheduledChangeDetailMessage } from './genericApiResponseScheduledChangeDetailMessage';
import type { GenericApiResponseScheduledChangeDetailPagination } from './genericApiResponseScheduledChangeDetailPagination';
import type { GenericApiResponseScheduledChangeDetailError } from './genericApiResponseScheduledChangeDetailError';

export interface GenericApiResponseScheduledChangeDetail {
  data?: GenericApiResponseScheduledChangeDetailData;
  message?: GenericApiResponseScheduledChangeDetailMessage;
  pagination?: GenericApiResponseScheduledChangeDetailPagination;
  error?: GenericApiResponseScheduledChangeDetailError;
  statusCode?: number;
}
